import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout, TwoColumns, Sidebar } from 'app/theme/layout'

export default function TermsConditionsPage() {
  return (
    <Layout className="container py-10">
      <TwoColumns sidebar={<Sidebar />}>
        <Helmet>
          <title>Terms And Conditions - Roaming Hunger</title>
          <meta
            name="description"
            content="Roaming Hunger is the hub for all things street food. Find and follow food trucks and food carts in your city live!"
          />
          <meta name="og:title" content="Terms And Conditions" />
        </Helmet>
        <h1 className="font-platform text-4xl leading-tight">
          ROAMING HUNGER LLC <br /> TERMS OF USE
        </h1>

        <p className="font-light text-sm my-2">
          <strong>Last Updated: 07/20/2020</strong>
        </p>

        <p className="font-light text-sm my-2">
          These Terms of Use are a legal agreement between you and Roaming Hunger, LLC 
          ("Roaming Hunger ," "us ," or "we") regarding your use of our
          website at www.roaminghunger.com (the "Website"), our "Roaming Hunger"
          mobile device application ("App"), and services provided by us via the
          Website and App (the Website, App, and services, collectively, the
          "Service"). BY CLICKING “I ACCEPT” OR PROVIDING A SIMILAR FORM OF
          CONSENT, BROWSING THE WEBSITE, DOWNLOADING AND INSTALLING THE APP, OR
          USING ANY PORTION OF THE SERVICE, YOU REPRESENT THAT (1) YOU HAVE READ,
          UNDERSTAND, AND AGREE TO BE BOUND BY THE TERMS, (2) YOU ARE OF LEGAL AGE
          TO FORM A BINDING CONTRACT WITH ROAMING HUNGER, AND (3) YOU HAVE THE
          AUTHORITY TO ENTER INTO THE TERMS PERSONALLY OR ON BEHALF OF THE COMPANY
          YOU REPRESENT.IF YOU DO NOT AGREE TO THESE TERMS OF USE, YOU MAY NOT ACCESS OR USE
          THE ANY PART OF THE SERVICE, INCLUDING BUT NOT LIMITED TO THE WEBSITE
          AND APP.
        </p>
        <p className="font-light text-sm my-2">
          <strong>
            THESE TERMS OF USE INCLUDE A CLASS ACTION WAIVER AND A WAIVER OF JURY
            TRIALS, AND REQUIRE BINDING ARBITRATION TO RESOLVE MOST DISPUTES
            UNLESS, IF YOU ARE A CONSUMER, YOU TIMELY EXERCISE YOUR OPT-OUT RIGHTS
            DESCRIBED IN THE SECTION BELOW ENTITLED “ARBITRATION”.
          </strong>
        </p>
        <p className="font-light text-sm my-2">
          <strong>
            THESE TERMS OF USE LIMIT THE REMEDIES THAT MAY BE AVAILABLE TO YOU IN
            THE EVENT OF A DISPUTE.
          </strong>
        </p>
        <p className="font-light text-sm my-2">
          PLEASE NOTE THAT The Terms OF USE are subject to change by ROAMING
          HUNGER in its sole discretion at any time. When changes are made, we
          will make a new copy of the Terms of Use available at the Website. We
          will also update the “Last Updated” date at the top of the Terms of Use.
          If we make any material changes, and you have provided us with your
          e-mail address, we will also send an e-mail to you at the last e-mail
          address you provided to us. Any changes to the Terms of Use (for new
          users of the Service) will be effective immediately, and (for existing
          users) will be effective upon the earlier of thirty (30) days after
          posting of notice of such changes on the Website or thirty (30) days
          after dispatch of an e-mail notice of such changes. Roaming Hunger may
          require you to provide consent to the updated Terms of Use in a
          particular specified manner before further use of the Service is
          permitted. If you do not agree to any change(s) after receiving a notice
          of such change(s), you shall stop using the Service. Otherwise, your
          continued use of the Service constitutes your acceptance of such
          change(s). PLEASE REGULARLY CHECK THE WEBSITE TO VIEW THE THEN-CURRENT
          TERMS OF USE.
        </p>
        <p className="font-light text-sm my-2">
          Your use of, and participation in, certain portions of the Service may
          be subject to additional terms (“Supplemental Terms”) which be presented
          to you for your acceptance when you sign up to use such portions of the
          Service, or when you enter into a separate agreement with Roaming Hunger
          for those portions. If these Terms of Use are inconsistent with the
          Supplemental Terms, the Supplemental Terms shall control with respect to
          such portions of the Service. The Supplemental Terms and Terms of Use
          are hereby referred to as the “Terms”.
        </p>

        <h2 className="font-normal text-2xl mt-2">Description of Service</h2>
        <p className="font-light text-sm my-2">
          The Service helps users to locate food trucks for their own dining
          purposes, and to reserve food trucks and food truck catering services
          for promotions or events. The Service also provides a food truck
          customer relationship management system (i.e., a dashboard) as well as a
          marketplace to connect (i) buyers and sellers of food trucks, (ii) food
          truck operators with third-party providers of food-truck-related
          services (such as truck leasing and customization services), and (iii)
          food truck catering services with individuals and businesses in need of
          catering services.
        </p>
        <p className="font-light text-sm my-2">
          While we provide information as part of our Service, such information is
          provided through the Service solely for convenience. We do not warrant
          that such information is up-to-date, accurate, or reliable, and you
          should take reasonable steps to confirm all information on the Service
          before choosing to rely on it. We do not have control over the quality,
          timing, legality, failure to provide, or any other aspect whatsoever of
          the food, beverages, food trucks, or other products or services sold or
          provided by users of our Service, or of the integrity, responsibility,
          or any actions of any users of our Service. We make no representations
          about the suitability, reliability, timeliness or accuracy of any user
          interactions, whether online or offline. When interacting with other
          users you should exercise caution and common sense to protect your
          personal safety and property, just as you would when interacting with
          other persons whom you don't know. NEITHER ROAMING HUNGER NOR ITS
          AFFILIATES (COLLECTIVELY, THE “ROAMING HUNGER PARTIES”) IS RESPONSIBLE
          FOR THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY USER OF THE SERVICES.
          the ROAMING HUNGER parties DO NOT INSPECT, WARRANT, OR ENDORSE ANY FOOD,
          FOOD TRUCKS, OR FOOD TRUCK RELATED SERVICES. YOU ACKNOWLEDGE AND AGREE
          THAT IT IS THE SOLE RESPONSIBILITY OF THE PRODUCT OR SERVICE PROVIDER
          INVOLVED IN ANY TRANSACTIONS (E.G., THE FOOD TRUCK owner or operator, OR
          OTHER PROVIDER OF FOOD TRUCK SERVICES), NOT ROAMING HUNGER, TO COMPLY
          WITH ALL APPLICABLE LAWS, RULES, AND REGULATIONS, INCLUDING BUT NOT
          LIMITED TO, APPLICABLE HEALTH AND SAFETY CODES AND VEHICLE SAFETY AND
          WARRANTY LAWS. THE ROAMING HUNGER PARTIES WILL NOT BE LIABLE FOR ANY
          CLAIM, INJURY OR DAMAGE ARISING IN CONNECTION WITH YOUR USE OF
          INFORMATION, PRODUCTS, OR SERVICES OBTAINED OR MADE AVAILABLE THROUGH
          THE SERVICE.
        </p>

        <h2 className="font-normal text-2xl mt-2">Account</h2>
        <p className="font-light text-sm my-2">
          Certain features of the Service may require you to create an account.
          When registering for a Roaming Hunger account, you must provide true,
          accurate, and complete information and promptly update this information
          to keep it current. You represent that you are (1) at least thirteen
          (13) years old and (2) not a person barred from using the Service under
          the laws of the United States, your place of residence or any other
          applicable jurisdiction. If you provide any information that is
          inaccurate or incomplete, or we have reason to believe that the
          information is inaccurate or incomplete, we may suspend or terminate
          your account and your use of the Service.
        </p>
        <p className="font-light text-sm my-2">
          You agree not to create an account using a false identity or false
          information, or on behalf of someone other than yourself. You agree that
          you shall not have more than one account at any time. You are solely
          responsible for: (a) maintaining the security of any logins, passwords,
          or other credentials that you select or that we provide to you to access
          your Roaming Hunger account; (b) all activities that occur through your
          account; and (c) exiting your account at the end of each session. To
          protect your account from unauthorized use, do not provide your username
          or password to anyone else. Please notify us immediately of any
          unauthorized use of your account or any other breach of security by
          sending an email to&nbsp;
          <a
            className="text-blue font-bold"
            href="mailto:support@roaminghunger.com"
          >
            support@roaminghunger.com
          </a>
          .
        </p>
        <p className="font-light text-sm my-2">
          If you register for an account by logging into a social networking
          service (“SNS”), you represent that you are entitled to disclose your
          SNS login information to us and/or grant us access to your SNS account
          (including, but not limited to, for use for the purposes described
          herein) without breach by you of any of the terms and conditions that
          govern your use of the applicable SNS account and without obligating us
          to pay any fees or making us subject to any usage limitations imposed by
          such third-party service providers. PLEASE NOTE THAT YOUR RELATIONSHIP
          WITH THE SNS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH SNS, AND
          WE DISCLAIM ANY LIABILITY FOR PERSONALLY IDENTIFIABLE INFORMATION THAT
          MAY BE PROVIDED TO US BY SUCH SNS IN VIOLATION OF THE PRIVACY SETTINGS
          THAT YOU HAVE SET IN YOUR SNS ACCOUNT.
        </p>
        <p className="font-light text-sm my-2">
          We reserve the right to remove or reclaim any usernames at any time and
          for any reason, including but not limited to, claims by a third party
          that a username violates the third party’s rights.
        </p>
        <p className="font-light text-sm my-2">
          You agree not to create an account or use the Service if you have been
          previously removed or banned from the Service.
        </p>
        <p className="font-light text-sm my-2">
          Notwithstanding anything to the contrary herein, you acknowledge and
          agree that you shall have no ownership or other property interest in
          your account, and you further acknowledge and agree that all rights in
          and to your account are and shall forever be owned by and inure to the
          benefit of Roaming Hunger.
        </p>

        <h2 className="font-normal text-2xl mt-2">License to the Service</h2>
        <p className="font-light text-sm my-2">
          The Service and all information and other content available therein are
          protected by copyright laws throughout the world. Unless otherwise
          specified by Roaming Hunger in a separate license, your right to use the
          Service is subject to the Terms.
        </p>
        <p className="font-light text-sm my-2">
          Subject to your compliance with these Terms, Roaming Hunger grants you a
          non-exclusive, non-assignable, non-transferable, non-sublicensable,
          revocable license to access and use the Service.
        </p>
        <p className="font-light text-sm my-2">
          Subject to your compliance with the Terms, Roaming Hunger grants you a
          non-exclusive, non-assignable, non-transferable, non-sublicensable,
          revocable license to download, install and use a copy of the App, on a
          single mobile device or computer that you own or control, solely as
          necessary to use the Service.
        </p>

        <h2 className="font-normal text-2xl mt-2">Restrictions</h2>
        <p className="font-light text-sm my-2">
          You must comply with all applicable laws when using the Service. Except
          as may be expressly permitted by applicable law or expressly enabled by
          a feature of the Service, you will not, and will not permit anyone else
          to: (a) store, copy, modify, or distribute any of the content made
          available on the Service; (b) compile or collect any content available
          on the Service as part of a database or other work; (c) use any
          automated tool (e.g., robots, spiders) or manual process to monitor,
          store, copy, scrape, modify, distribute, or resell any content from the
          Service; (d) frame or otherwise incorporate the Service or any portion
          of the Service as part of another website or service; (e) reverse
          engineer (except as permitted by applicable law), decompile, reproduce,
          duplicate, copy, sell, resell, or exploit for any commercial purposes
          any portion of the Service; (f) you may not use the Service for third
          party advertising purposes; (g) circumvent or disable any digital rights
          management, usage rules, or other security features of the Service; (h)
          use the Service in a manner that threatens the integrity, performance,
          or availability of the Service; (i) remove, alter, or obscure any
          proprietary notices (including copyright, trademark, service mark, or
          other proprietary notices) incorporated in or accompanying on any
          portion of the Service or any content available from the Service; or (j)
          use the Service, in whole or in part, to build a competitive service.
        </p>

        <h2 className="font-normal text-2xl mt-2">Business Information</h2>
        <p className="font-light text-sm my-2">
            If you are a vendor/independent contractor of Roaming Hunger, you 
            acknowledge and agree that Roaming Hunger may receive from, and 
            collect and share with, its vendors and business partners, your 
            business contact information, order-related transactional data 
            (e.g. type and quantity of food sold, food sale prices, food sale 
            locations, etc.), data related to your business’s financial 
            and/or operational performance, data related to your use of the 
            Service, and other business information (collectively, “Business 
            Information”). You hereby grant Roaming Hunger and its subsidiaries, 
            affiliates, and successors a worldwide, non-exclusive, royalty-free, 
            fully-paid, perpetual, irrevocable, transferable, and fully sublicensable 
            right to use, reproduce, modify, adapt, publish, translate, prepare 
            derivative works of, distribute, and display Business Information for 
            the purposes of operating and improving the Services; to create and 
            publicly display aggregate, anonymous data; and to share such Business 
            Information and aggregate, anonymous data with its vendors and business 
            partners to provide services for Roaming Hunger and for such entities’ 
            own internal business purposes.
        </p>

        <h2 className="font-normal text-2xl mt-2">User Content</h2>
        <p className="font-light text-sm my-2">
          The Service may incorporate a feature that allows users to upload and
          post photos or other materials or information on the Service ("User
          Content"). You User Content includes that which you make available on
          the Service and, with respect to vendors/independent contractors of
          Roaming Hunger (“Vendors”), your trademarks, trade names, service names,
          logos, and designations (“Vendor Marks”). You agree that you, and not
          Roaming Hunger, are solely responsible for all User Content that you
          make available on the Service. You represent that you own and/or have a
          royalty-free, perpetual, irrevocable, worldwide, non-exclusive right
          (including any moral rights) and license to use, license, reproduce,
          modify, adapt, publish, translate, create derivative works from,
          distribute, derive revenue or other remuneration from, and communicate
          to the public, perform and display your User Content (in whole or in
          part) worldwide and/or to incorporate it in other works in any form,
          media or technology now known or later developed, for the full term of
          any worldwide intellectual property right that may exist in your User
          Content. For any User Content that you make available on the Service,
          you grant us and our subsidiaries, affiliates, and successors a
          worldwide, non-exclusive, royalty-free, fully-paid, perpetual,
          irrevocable, transferable, and fully sublicensable right to use,
          reproduce, modify, adapt, publish, translate, prepare derivative works
          of, distribute, publicly perform, and publicly display that User Content
          throughout the world in any media in connection with the Service and
          Roaming Hunger’s business, including without limitation for promoting
          the Service. During the term of these Terms, if you are a Vendor, you
          grant Roaming Hunger a worldwide, non-exclusive, and fully sublicensable
          right (including any moral rights) and license to use, license,
          reproduce, modify, adapt, publish, distribute, and communicate to the
          public, perform and display your Vendor Marks for the purposes of
          operating, providing, enhancing, improving, promoting, supporting, and
          maintaining, the Service and Roaming Hunger’s business offerings. You
          retain all rights in your User Content, subject to the rights granted to
          Roaming Hunger in these Terms. Please remember that other users may
          search for, see, use, modify and reproduce any of your User Content that
          you submit to any “public” area of the Service. You warrant that the
          holder of any worldwide intellectual property right, including moral
          rights, in your User Content, has completely and effectively waived all
          such rights and validly and irrevocably granted to you the right to
          grant the license stated above.
        </p>

        <p className="font-light text-sm my-2">
          Notwithstanding anything contained herein to the contrary, by making
          your User Content available on the Service, you hereby expressly permit
          us to identify you by your username as the contributor of your User
          Content in any publication in any form, media or technology now known or
          later developed in connection with your User Content. Notwithstanding
          anything contained herein to the contrary, Roaming Hunger may use any
          anonymized, non-aggregated data that it derives based upon your User
          Content or use of the Services for any business purposes. Any User
          Content posted by you in your profile may not contain nudity, violence,
          sexually explicit, or offensive subject matter.
        </p>
        <p className="font-light text-sm my-2">
          You may not post or submit for print services a photograph of another
          person without that person’s permission.
        </p>
        <p className="font-light text-sm my-2">
          You agree not to upload to the Service or otherwise post, transmit, 
          distribute, or disseminate through the Service any material that: (i) is 
          false, misleading, unlawful, obscene, indecent, lewd, pornographic, 
          defamatory, libelous, threatening, harassing, hateful, inflammatory, or 
          abusive; (ii) encourages conduct that would be considered a criminal 
          offense or gives rise to civil liability; (iii) breaches any duty toward 
          or rights of any person or entity, including rights of publicity or 
          privacy; (iv) contains corrupted data or any other harmful, disruptive, 
          or destructive files; (v) advertises products or services competitive 
          with Roaming Hunger’s or its partners’ products and services, as 
          determined by Roaming Hunger in its sole discretion; (vi) in Roaming 
          Hunger’s sole judgment, is objectionable, restricts or inhibits any 
          person or entity from using or enjoying any portion of the Service, 
          or which may expose Roaming Hunger, its affiliates, or users to harm or 
          liability of any nature.
        </p>

        <p className="font-light text-sm my-2">
          You acknowledge that Roaming Hunger has no obligation to pre-screen any
          content on the Service, including but not limited to User Content,
          although Roaming Hunger reserves the right, and has absolute discretion,
          to remove, screen, edit, or disable any User Content at any time and for
          any reason without notice. By entering into the Terms, you hereby
          provide your irrevocable consent to such monitoring. You acknowledge and
          agree that you have no expectation of privacy concerning the
          transmission of your User Content. We reserve the right to investigate
          any potential violations of these Terms or applicable law, and we may,
          in our sole discretion, immediately terminate your license to use the
          Service, delete your account, or pre-screen, refuse, or remove any
          content. In the event that we take any actions, you acknowledge that we
          will do so for our benefit, not yours. Without limiting the foregoing,
          we shall have the right to remove any content that violates the Terms or
          is otherwise objectionable in our sole determination.
        </p>
        <p className="font-light text-sm my-2">
          You are solely responsible for your interaction with other users of the
          Service, whether online or offline. We are not responsible or liable for
          the conduct or content of any user. We reserve the right, but have no
          obligation, to monitor or intercede in disputes between you and other
          users. Exercise common sense and your best judgment in your interactions
          with others (e.g., when you submit any personal or other information)
          and in all of your other activities, whether online or offline. You
          agree that Roaming Hunger will not be responsible for any liability
          incurred as the result of such interactions.
        </p>
        <p className="font-light text-sm my-2">
          Any opinion, advice, statement, service, offer, or other information
          that constitutes part of the User Content expressed or made available
          via the Service are those of the respective authors or producers and not
          of Roaming Hunger or its directors, officers, employees, agents,
          representatives, partners, or affiliates. Under no circumstances will
          Roaming Hunger or its directors, officers, employees, agents,
          representatives, partners, or affiliates be held liable for any loss or
          damage caused by your reliance on any information obtained through the
          Service. We do not approve, endorse or make any representations or
          warranties with respect to User Content. You use all User Content and
          interact with other users at your own risk. It is your responsibility to
          evaluate the information, opinions, advice, or other content available
          on the Service and to seek qualified professional assistance as
          applicable.
        </p>

        <h2 className="font-normal text-2xl mt-2">Privacy</h2>
          <p className="font-light text-sm my-2">
            You acknowledge and agree that Roaming Hunger may collect, use, 
            and share personally identifiable information in accordance with 
            Roaming Hunger’s Privacy Policy (https://privacy.cptn.co/privacy-policy/6e1b0402-6e56-453c-9c37-de518dddb75d).
          </p>


        <h2 className="font-normal text-2xl mt-2">Copyright Infringement</h2>
        <p className="font-light text-sm my-2">
          <strong>Procedure for Making Claims of Copyright Infringement.</strong>
          It is Roaming Hunger’s policy to terminate membership privileges of any
          user who repeatedly infringes copyright upon prompt notification to
          Roaming Hunger by the copyright owner or the copyright owner’s legal
          agent. Without limiting the foregoing, if you believe that your work has
          been copied and posted on Roaming Hunger in a way that constitutes
          copyright infringement, please provide our Copyright Agent with the
          following information:
          <br />
          <br />
          (i) A physical or electronic signature of a person authorized to act on
          behalf of the owner of an exclusive right that is allegedly infringed.
          <br />
          <br />
          (ii) Identification of the copyrighted work claimed to have been
          infringed, or, if multiple copyrighted works at a single online site are
          covered by a single notification, a representative list of such works at
          that site.
          <br />
          <br />
          (iii) Identification of the material that is claimed to be infringing or
          to be the subject of infringing activity and that is to be removed or
          access to which is to be disabled, and information reasonably sufficient
          to permit the service provider to locate the material.
          <br />
          <br />
          (iv) Information reasonably sufficient to permit the service provider to
          contact the complaining party such as an address, telephone number, and
          if available, an electronic mail address at which the complaining party
          may be contacted.
          <br />
          <br />
          (v) A statement that the complaining party has a good faith belief that
          use of the material in the manner complained of is not authorized by the
          copyright owner, its agent, or the law.
          <br />
          <br />
          (vi) A statement that the information in the notification is accurate,
          and under penalty of perjury, that the complaining party is authorized
          to act on behalf of the owner of an exclusive right that is allegedly
          infringed.
        </p>
        <p className="font-light text-sm my-2">
          Then send this notice to:
          <br />
          <br />
          <strong>By Mail:</strong>
          <br />
          DMCA Agent:
          <br />
          Roaming Hunger LLC
          <br />
          10951 W Pico Blvd, Ste 300
          <br />
          Los Angeles, CA 90064
          <br />
          <br />
          <strong>By Email:</strong>{' '}
          <a className="text-blue font-bold" href="mailto:dmca@roaminghunger.com">
            dmca@roaminghunger.com
          </a>
        </p>

        <h2 className="font-normal text-2xl mt-2">Ownership</h2>
        <p className="font-light text-sm my-2">
          Except with respect to User Content, you agree that Roaming Hunger and
          its licensors and suppliers own all rights, title and interest in
          Service, including but not limited to, any content appearing on or in
          the Service.
        </p>
        <p className="font-light text-sm my-2">
          Roaming Hunger’s stylized name and other related graphics, logos,
          service marks and trade names used on or in connection with the Service
          are the trademarks of Roaming Hunger and may not be used without
          permission in connection with any third-party products or services.
          Other trademarks, service marks and trade names that may appear on or in
          Service are the property of their respective owners.
        </p>
        <p className="font-light text-sm my-2">
          Except with respect to your User Content, you agree that you have no
          right or title in or to any content that appears on or in the Service.
        </p>

        <h2 className="font-normal text-2xl mt-2">Fees</h2>
        <p className="font-light text-sm my-2">
          As of the date stated above, unless you have entered into Supplemental
          Terms, the Service is provided to you for free, but Roaming Hunger
          reserves the right to implement fees for the Service at any time by
          providing you notice in accordance with the change procedures described
          at the beginning of these Terms of Use. If you pay for services provided
          by Roaming Hunger or the food trucks via the Service, upon the request
          of Roaming Hunger, you shall make payments via Roaming Hunger’s
          designated third party payment processor (e.g., Stripe) (“Processor”).
          In such case, Processor will be able to process credit card payments and
          refunds, store and manage credit cards, permit you to view transactions,
          deliver automated receipts, and receive notification of payment
          disputes. Processor may require you to executed its own legal terms and
          conditions. Roaming Hunger is not a party to such agreement and shall
          not have any liability or responsibility for any breach of it, or any
          losses, damages, expenses costs or other injuries incurred by you in
          connection with such agreement. Roaming Hunger is not responsible for,
          and expressly disclaims all direct and indirect, incidental,
          consequential, punitive, exemplary, special or other damages in
          connection with (i) any technical issues, errors, unavailability or
          failures, losses, damages, loss of data, lost profits or other losses or
          claims originating from or arising in connection with the Processor
          platform; (ii) any unauthorized access, hacking, tampering with or to
          your account or the Processor’s services by third parties; or (iii) any
          software, bugs, viruses, Trojan horses, or other harmful and malicious
          code that may be transmitted via the Processor platform.
        </p>
        <p className="font-light text-sm my-2">
          Access; Modifications to the Service
        </p>
        <p className="font-light text-sm my-2">
          Roaming Hunger does not provide you with the equipment to use the
          Service. You are responsible for all fees charged by third parties to
          access and use the Service (e.g., charges by ISPs or mobile
          carriers).Roaming Hunger reserves the right to modify or discontinue,
          temporarily or permanently, all or a part of the Service without notice.
          Roaming Hunger will not be liable to you or to any third party for any
          modification, suspension, or discontinuance of the Service.
        </p>

        <h2 className="font-normal text-2xl mt-2">Feedback</h2>
        <p className="font-light text-sm my-2">
          If you provide feedback to Roaming Hunger regarding the Service
          ("Feedback"), you acknowledge that the Feedback is not confidential and
          you authorize Roaming Hunger to use that Feedback without restriction
          and without payment to you. Accordingly, you hereby grant to Roaming
          Hunger a nonexclusive, royalty-free, fully-paid, perpetual, irrevocable,
          transferable, and fully sublicensable right to use the Feedback in any
          manner and for any purpose.
        </p>

        <h2 className="font-normal text-2xl mt-2">Term and Termination</h2>
        <p className="font-light text-sm my-2">
          The Terms of Use commence on the date when you accept them (as described
          in the preamble above) and remain in full force and effect while you use
          the Service, unless terminated earlier in accordance with the Terms of
          Use.
        </p>
        <p className="font-light text-sm my-2">
          If you have materially breached any provision of the Terms, if we are
          required to do so by law (e.g., where the provision of any of the
          Service is, or becomes, unlawful), or if we choose to discontinue the
          Service (in part or in whole), we have the right to, immediately and
          without notice, suspend or terminate the Service provided to you. If we
          become aware of any possible violations by you of the Terms, we reserve
          the right to investigate such violations. In the event that we
          determine, in our sole discretion, that you have breached any portion of
          the Terms, or have otherwise demonstrated inappropriate conduct, we
          reserve the right to (i) warn you via e-mail (to any e-mail address you
          have provided to us) that you have violated the Terms; (ii) notify
          and/or send any content you have provided to us to and/or fully
          cooperate with the proper law enforcement authorities for further
          action; and/or (iii) pursue any other action which we deem to be
          appropriate. If, as a result of the investigation, we believe that
          illegal activity has occurred, we reserve the right to refer the matter
          to, and to cooperate with, any and all applicable legal authorities. We
          are entitled, except to the extent prohibited by applicable law, to
          disclose any information or materials on or in the Service in our
          possession in connection with your use of the Service, including but not
          limited to, your User Content, to (i) comply with applicable laws, legal
          process or governmental request; (ii) enforce the Terms; (iii) respond
          to your requests for customer service; or (iv) protect the rights,
          property or personal safety of Roaming Hunger, its users or the public,
          and to comply with the requests of all law enforcement or other
          government officials, as we in our sole discretion believe to be
          necessary or appropriate. We reserve the right, in our sole discretion,
          to immediately take any or all of the actions set forth herein without
          any notice or warning to you. You agree that all terminations shall be
          made in our sole discretion and that we shall not be liable to you or
          any third-party for enforcing this provision.
        </p>
        <p className="font-light text-sm my-2">
          You may terminate your use of the Service at any time by terminating
          your account and deleting the App from your mobile device. Termination
          of your account is your sole right and remedy with respect to any
          dispute with Roaming Hunger regarding the Service or the Terms.
        </p>
        <p className="font-light text-sm my-2">
          Upon termination of your account or your access to the Service, your
          right to use the Service terminates immediately and you must destroy or
          delete any copy of the App in your possession.Termination of your
          account or access may include deletion of your account, including your
          User Content from our live databases. You remain solely liable for all
          obligations related to use of the Service, even after you have stopped
          using the Service. Neither Roaming Hunger nor any of its licensors,
          suppliers, or publishers is liable to you or to any third party for any
          loss caused by any suspension or termination of the Service or your
          access to the Service, including for deletion of any content or other
          data. All provisions of the Terms which by their nature should survive,
          shall survive termination of your account or access to the Service,
          including without limitation, ownership provisions, warranty
          disclaimers, and limitation of liability.
        </p>
        <p className="font-light text-sm my-2">
          If your registration(s) with or ability to access the Service is
          terminated by Roaming Hunger due to your violation of any portion of the
          Terms or for otherwise inappropriate conduct, then you agree that you
          shall not attempt to re-register with or access the Service through use
          of a different member name or otherwise. In the event that you violate
          the immediately preceding sentence, Roaming Hunger reserves the right,
          in its sole discretion, to immediately take any or all of the actions
          set forth herein without any notice or warning to you.
        </p>

        <h2 className="font-normal text-2xl mt-2">Third-Party Content</h2>
        <p className="font-light text-sm my-2">
          We may email or provide you coupons, offers, and other specials from
          Roaming Hunger or third parties (collectively "Promotions"). Roaming
          Hunger is not responsible for the redemption, errors, omissions, or
          expiration of any third party Promotions. All Promotions featured as a
          part of the Service are subject to change without notice and we have no
          control over their legality or the ability of any third party merchant
          to complete the Promotion (including the sale in accordance with the
          offer).
        </p>
        <p className="font-light text-sm my-2">
          The Service may contain links to third-party websites (“Third-Party
          Websites”) and applications (“Third-Party Applications”) and
          advertisements for third parties (collectively, “Third-Party Ads”). When
          you click on a link to a Third-Party Website, Third-Party Application or
          Third-Party Ad, we will not warn you that you have left the Service and
          are subject to the terms and conditions (including privacy policies) of
          another website or destination. Such Third-Party Websites, Third-Party
          Applications and Third-Party Ads are not under our control. We are not
          responsible for any Third-Party Websites, Third-Party Applications or
          Third-Party Ads. We provide these Third-Party Websites, Third-Party
          Applications and Third Party Ads only as a convenience and do not
          review, approve, monitor, endorse, warrant, or make any representations
          with respect to Third-Party Websites, Third-Party Applications or
          Third-Party Ads, or their products or services. You use all links in
          Third-Party Websites, Third-Party Applications and Third-Party Ads at
          your own risk. When you leave our Service, our Terms and policies no
          longer govern. You should review applicable terms and policies,
          including privacy and data gathering practices, of any Third-Party
          Websites or Third-Party Applications, and should make whatever
          investigation you feel necessary or appropriate before proceeding with
          any transaction with any third party.
        </p>

        <h2 className="font-normal text-2xl mt-2">App Stores</h2>
        <p className="font-light text-sm my-2">
          You acknowledge and agree that the availability of the App and the
          Service is dependent on the third party from whom you received the App
          license, e.g., the Apple App Store or Google Play (“App Store”). You
          acknowledge that the Terms are between you and Roaming Hunger and not
          with the App Store. Roaming Hunger, not the App Store, is solely
          responsible for the App, the content thereof, maintenance, support
          services, and warranty therefor, and addressing any claims relating
          thereto (e.g., product liability, legal compliance or intellectual
          property infringement). In order to use the App, you must have access to
          a wireless network, and you agree to pay all fees associated with such
          access. You also agree to pay all fees (if any) charged by the App Store
          in connection with the Service. You agree to comply with, and your
          license to use the App is conditioned upon your compliance with, all
          applicable third-party terms of agreement (e.g., the App Store’s terms
          and policies) when using the Service. You acknowledge that the App Store
          (and its subsidiaries) are third-party beneficiaries of the Terms and
          will have the right to enforce them.
        </p>

        <h2 className="font-normal text-2xl mt-2">
          Special Terms Regarding Apple
        </h2>
        <p className="font-light text-sm my-2">
          If you download the App from Apple, Inc.’s App Store: (a) your use of
          the App must at all times be in accordance with the Usage Rules set
          forth in the Apple, Inc. App Store Terms of Service; (b) you may only
          use the App on an Apple-branded product that runs iOS and (c) you
          acknowledge that these Terms are entered into solely between you and
          Roaming Hunger. These Terms are not intended to provide for usage rules
          for the App that are less restrictive than the Usage Rules set forth for
          Licensed Applications in, or otherwise conflict with, the App Store
          Terms of Service as of the date that you accept the App Store Terms of
          Service (which you acknowledge you have had the opportunity to review).
          You also acknowledge and agree that:
        </p>
        <p className="font-light text-sm my-2">
          Apple has no obligation whatsoever to furnish any maintenance and
          support services with respect to the App.
        </p>
        <p className="font-light text-sm my-2">
          In the event of any failure of the App to conform to any applicable
          warranty, you may notify Apple, and Apple will refund the purchase price
          for the App to you and to the maximum extent permitted by applicable
          law, Apple will have no other warranty obligation whatsoever with
          respect to the App. As between Roaming Hunger and Apple, any other
          claims, losses, liabilities, damages, costs or expenses attributable to
          any failure to conform to any warranty will be the sole responsibility
          of Roaming Hunger.
        </p>
        <p className="font-light text-sm my-2">
          As between Roaming Hunger and Apple, Apple is not responsible for
          addressing any claims you have or any claims of any third party relating
          to the App or your possession and use of the App, including, but not
          limited to: (i) product liability claims; (ii) any claim that the App
          fails to conform to any applicable legal or regulatory requirement; and
          (iii) claims arising under consumer protection or similar legislation.
        </p>
        <p className="font-light text-sm my-2">
          In the event of any third-party claim that the App or your possession
          and use of that App infringes that third party’s intellectual property
          rights, as between Roaming Hunger and Apple, Roaming Hunger, not Apple,
          will be solely responsible for the investigation, defense, settlement
          and discharge of any such intellectual property infringement claim to
          the extent required by the Terms.
        </p>
        <p className="font-light text-sm my-2">
          Apple, and Apple’s subsidiaries, are third-party beneficiaries of the
          Terms as related to your license of the App, and that, upon your
          acceptance of the terms and conditions of the Terms, Apple will have the
          right (and will be deemed to have accepted the right) to enforce the
          Terms as related to your license of the App against you as a third-party
          beneficiary thereof.
        </p>
        <p className="font-light text-sm my-2">
          Without limiting any other terms of the Terms, you must comply with all
          applicable third-party terms of agreement when using the App.
        </p>

        <h2 className="font-normal text-2xl mt-2">Disclaimer of Warranties</h2>
        <p className="font-light text-sm my-2">
          YOU EXPRESSLY UNDERSTAND AND AGREE THAT TO THE EXTENT PERMITTED BY
          APPLICABLE LAW, YOUR USE OF THE SERVICE IS AT YOUR SOLE RISK. THE
          SERVICE IS PROVIDED ON AN "AS IS " AND "AS AVAILABLE" BASIS WITH ALL
          FAULTS. THE ROAMING HUNGER PARTIES EXPRESSLY DISCLAIM ALL WARRANTIES OF
          ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE
          IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
          TITLE, AND NON-INFRINGEMENT.
        </p>
        <p className="font-light text-sm my-2">
          THE ROAMING HUNGER PARTIES MAKE NO WARRANTY, REPRESENTATION OR CONDITION
          THAT: (1) THE SERVICE WILL MEET YOUR REQUIREMENTS; (2) YOUR USE OF THE
          SERVICE WILL BE UNINTERRUPTED, TIMELY, SECURE OR ERROR-FREE; (3) THE
          RESULTS THAT MAY BE OBTAINED FROM USE OF THE SERVICE WILL BE ACCURATE OR
          RELIABLE; OR (4) ANY ERRORS IN THE SERVICE WILL BE CORRECTED.
        </p>
        <p className="font-light text-sm my-2">
          ANY CONTENT DOWNLOADED FROM OR OTHERWISE ACCESSED THROUGH THE SERVICE IS
          ACCESSED AT YOUR OWN RISK, AND YOU SHALL BE SOLELY RESPONSIBLE FOR ANY
          DAMAGE TO YOUR PROPERTY OR PERSON, INCLUDING, BUT NOT LIMITED TO, YOUR
          COMPUTER SYSTEM AND ANY DEVICE YOU USE TO ACCESS THE SERVICE, OR ANY
          OTHER LOSS THAT RESULTS FROM ACCESSING SUCH CONTENT.
        </p>
        <p className="font-light text-sm my-2">
          THE SERVICE MAY BE SUBJECT TO DELAYS, CANCELLATIONS AND OTHER
          DISRUPTIONS. THE ROAMING HUNGER PARTIES MAKE NO WARRANTY, REPRESENTATION
          OR CONDITION WITH RESPECT TO SERVICE, INCLUDING BUT NOT LIMITED TO, THE
          QUALITY, EFFECTIVENESS, REPUTATION AND OTHER CHARACTERISTICS OF SERVICE.
        </p>
        <p className="font-light text-sm my-2">
          THE ROAMING HUNGER PARTIES DO NOT WARRANT THAT ANY FOOD TRUCK
          INFORMATION WILL BE ACCURATE, INCLUDING BUT NOT LIMITED TO, THE
          DESCRIPTION OF THE FOOD TRUCK OR LOCATION OF A FOOD TRUCK. PLEASE
          CONTACT THE APPLICABLE FOOD TRUCK OPERATOR TO CONFIRM FOOD TRUCK
          INFORMATION PRIOR TO VISITING THE FOOD TRUCK LOCATION.
        </p>
        <p className="font-light text-sm my-2">
          The Roaming Hunger Parties make no warranty regarding the quality of any
          goods, or the accuracy, timeliness, truthfulness, completeness or
          reliability of any User Content obtained through the Service. While we
          may help facilitate the resolution of disputes through various programs,
          we have no control over and do not guarantee the quality, safety or
          legality of items advertised, the truth or accuracy of users’ content or
          listings, the ability of sellers to sell items, the ability of buyers to
          pay for item, or that any buyer or seller will actually complete a
          transaction. We do not transfer legal ownership of items from a seller
          to a buyer.&nbsp; California Commercial Code § 2401(2) and Uniform
          Commercial Code § 2-401(2) apply to the transfer of ownership between
          the buyer and the seller, unless the buyer and the seller agree
          otherwise. We cannot guarantee continuous or secure access to the
          Service and operation of the service may be interfered with by numerous
          factors outside of our control. Accordingly, to the extent legally
          permitted, we exclude all implied warranties, terms, and conditions.
        </p>
        <p className="font-light text-sm my-2">
          NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM ROAMING
          HUNGER OR THROUGH THE SERVICE WILL CREATE ANY WARRANTY NOT EXPRESSLY
          MADE HEREIN.
        </p>
        <p className="font-light text-sm my-2">
          YOU ACKNOWLEDGE AND AGREE THAT THE ROAMING HUNGER PARTIES ARE NOT
          LIABLE, AND YOU AGREE NOT TO SEEK TO HOLD THE ROAMING HUNGER PARTIES
          LIABLE, FOR THE CONDUCT OF THIRD PARTIES, INCLUDING OPERATORS OF
          EXTERNAL SITES, AND THAT THE RISK OF INJURY FROM SUCH THIRD PARTIES
          RESTS ENTIRELY WITH YOU.
        </p>
        <p className="font-light text-sm my-2">
          YOU ARE SOLELY RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS AND
          INTERACTIONS WITH OTHER USERS OF THE SERVICE. YOU UNDERSTAND THAT THE
          ROAMING HUNGER PARTIES DO NOT MAKE ANY ATTEMPT TO VERIFY THE STATEMENTS
          OF USERS OF THE sERVICE. THE ROAMING HUNGER PARTIES MAKE NO
          REPRESENTATIONS OR WARRANTIES AS TO THE CONDUCT OF USERS OF THE SERVICE.
          YOU AGREE TO TAKE REASONABLE PRECAUTIONS IN ALL COMMUNICATIONS AND
          INTERACTIONS WITH OTHER USERS OF THE SERVICE.
        </p>
        <p className="font-light text-sm my-2">
          SOME STATES MAY PROHIBIT A DISCLAIMER OF CERTAIN WARRANTIES AND YOU MAY
          HAVE OTHER RIGHTS THAT VARY FROM STATE TO STATE.
        </p>

        <h2 className="font-normal text-2xl mt-2">Limitation of Liability</h2>
        <p className="font-light text-sm my-2">
          THE ROAMING HUNGER PARTIES WILL NOT BE LIABLE FOR ANY INDIRECT,
          INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES OR DAMAGES FOR
          LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES OR
          DAMAGES OR COSTS DUE TO LOSS OF PRODUCTION OR USE, BUSINESS
          INTERRUPTION, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, OR PERSONAL
          OR PROPERTY DAMAGE OR EMOTIONAL DISTRESS, EVEN IF THE ROAMING HUNGER
          PARTIES HAVE BEEN ADVISED OF THE POSSIBILITY OF THESE DAMAGES, ARISING
          OUT OF OR IN CONNECTION WITH THE TERMS, THE SERVICE, OR FROM ANY
          COMMUNICATIONS, INTERACTIONS OR MEETINGS WITH OTHER USERS OF THE
          SERVICE, ON ANY THEORY OF LIABILITY, INCLUDING WITHOUT LIMITATION THOSE
          RESULTING FROM: (1) THE USE OR INABILITY TO USE THE SERVICE; (2) THE
          COST OF PROCUREMENT OF SUBSTITUTE SERVICES RESULTING FROM ANY DATA,
          INFORMATION OR SERVICES PURCHASED OR OBTAINED OR MESSAGES RECEIVED FOR
          TRANSACTIONS ENTERED INTO ARISING OUT OF THE USE OF THE SERVICE; (3)
          UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; (4)
          STATEMENTS OR CONDUCT OF ANY THIRD PARTY ON THE SERVICE; OR (5) ANY
          OTHER MATTER RELATED TO THE SERVICE, WHETHER BASED ON WARRANTY,
          COPYRIGHT, CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR
          ANY OTHER LEGAL THEORY. EXCEPT AS OTHERWISE EXPRESSLY SET FORTH IN THESE
          TERMS, THE MAXIMUM TOTAL AGGREGATE LIABILITY OF THE ROAMING HUNGER
          PARTIES TO YOU FOR ANY CLAIM RELATED TO THE SERVICE, WHETHER IN
          CONTRACT, TORT, OR OTHERWISE, SHALL NOT EXCEED THE GREATER OF (A) THE
          TOTAL AMOUNT OF ALL FEES PAID TO ROAMING HUNGER BY YOU IN THE TWELVE
          (12) MONTHS PRECEDING THE EVENT GIVING RISE TO THE CLAIM OF LIABILITY OR
          (B) ONE HUNDRED U.S. DOLLARS (USD $100).
        </p>
        <p className="font-light text-sm my-2">
          THE ROAMING HUNGER PARTIES ASSUME NO RESPONSIBILITY FOR THE TIMELINESS,
          DELETION, MIS-DELIVERY OR FAILURE TO STORE ANY CONTENT (INCLUDING, BUT
          NOT LIMITED TO, YOUR USER CONTENT OR PERSONALIZATION SETTINGS).
        </p>
        <p className="font-light text-sm my-2">
          THE LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF
          THE BASIS OF THE BARGAIN BETWEEN ROAMING HUNGER AND YOU.
        </p>
        <p className="font-light text-sm my-2">
          BECAUSE SOME STATES DO NOT ALLOW THE CERTAIN EXCLUSIONS OR LIMITATIONS
          OF LIABILITY, THE ABOVE LIMITATION MAY NOT APPLY TO YOU.
        </p>

        <h2 className="font-normal text-2xl mt-2">Indemnity</h2>
        <p className="font-light text-sm my-2">
          You will defend, indemnify, and hold Roaming Hunger, its affiliates,
          directors, officers, agents, employees, licensors, suppliers, and
          distributors harmless from any costs, damages, expenses, and liability
          arising out of or in connection with your use of the Service, your User
          Content, your violation of these Terms, your violation of any rights of
          a third party through use of the Service, or your violation of any
          applicable laws, rules, or regulations. We reserve the right, at our own
          cost, to assume the exclusive defense and control of any matter
          otherwise subject to indemnification by you, in which event you will
          fully cooperate with us in asserting any available defenses. You agree
          that the provisions in this section will survive any termination of your
          account, the Terms or your access to the Service.
        </p>

        <h2 className="font-normal text-2xl mt-2">Assignment</h2>
        <p className="font-light text-sm my-2">
          The Terms, and your rights and obligations hereunder, may not be
          assigned, subcontracted, delegated, or otherwise transferred by you
          without Roaming Hunger’s prior written consent, and any attempted
          assignment, subcontract, delegation, or transfer in violation of the
          foregoing will be null and void.
        </p>

        <h2 className="font-normal text-2xl mt-2">Arbitration</h2>
        <p className="font-light text-sm my-2">
          Except as expressly provided herein, all claims and disputes (excluding
          claims for emergency injunctive relief as set forth below) in connection
          with the Terms or the use of any product or service provided by Roaming
          Hunger that cannot be resolved informally or in small claims court shall
          be resolved exclusively by binding arbitration on an individual basis
          under the terms of this arbitration provision (“
          <strong>Arbitration Agreement</strong>”). Unless otherwise agreed to,
          all arbitration proceedings shall be held in English. This Arbitration
          Agreement applies to you and Roaming Hunger, and to any subsidiaries,
          affiliates, agents, employees, predecessors in interest, successors, and
          assigns, as well as all authorized or unauthorized users or
          beneficiaries of services or goods provided under the Terms.
        </p>
        <p className="font-light text-sm my-2">
          Before either party may seek arbitration, the party must first send to
          the other party a written Notice of Dispute (“<strong>Notice</strong>”)
          describing the nature and basis of the claim or dispute, and the
          requested relief. A Notice to Roaming Hunger should be sent
          to:&nbsp;Roaming Hunger LLC, Attn: Legal, 10951 W Pico Blvd, Ste 300, Los Angeles, CA 90064. After the Notice is received, you and
          Roaming Hunger may attempt to resolve the claim or dispute informally.
          If you and Roaming Hunger do not resolve the claim or dispute within
          thirty (30) days after the Notice is received, either party may begin an
          arbitration proceeding. The amount of any settlement offer made by any
          party may not be disclosed to the arbitrator until after the arbitrator
          has determined the amount of the award, if any, to which either party is
          entitled.
        </p>
        <p className="font-light text-sm my-2">
          Arbitration shall be initiated through the American Arbitration
          Association (“<strong>AAA</strong>”), an established alternative dispute
          resolution provider (“<strong>ADR Provider</strong>”) that offers
          arbitration as set forth in this section. If AAA is not available to
          arbitrate, the parties shall agree to select an alternative ADR
          Provider. The rules of the ADR Provider shall govern all aspects of the
          arbitration, including but not limited to the method of initiating
          and/or demanding arbitration, except to the extent such rules are in
          conflict with the Terms. The AAA Consumer Arbitration Rules governing
          the consumer arbitrations held before the AAA are available online
          at&nbsp;
          <a
            className="text-blue font-bold"
            href="http://www.adr.org"
            target="_blank"
          >
            www.adr.org
          </a>
          &nbsp;or by calling the AAA at 1-800-778-7879. The arbitration shall be
          conducted by a single, neutral arbitrator. Any claims or disputes where
          the total amount of the award sought is less than Ten Thousand U.S.
          Dollars (US $10,000.00) may be resolved through binding
          non-appearance-based arbitration, at the option of the party seeking
          relief. For claims or disputes where the total amount of the award
          sought is Ten Thousand U.S. Dollars (US $10,000.00) or more, the right
          to a hearing will be determined by the Arbitration Rules. If
          non-appearance based arbitration is elected, the arbitration shall be
          conducted by telephone, online and/or based solely on written
          submissions; the specific manner shall be chosen by the party initiating
          the arbitration.{' '}
        </p>
        <p className="font-light text-sm my-2">
          <u>If you are a consumer and not a Roaming Hunger Vendor</u>:
          Notwithstanding the foregoing, you have the right to opt out of the
          arbitration provisions of this Arbitration Agreement by mailing written
          notice of your decision to opt out to the following
          address:&nbsp;Roaming Hunger LLC, Attn: Legal, 10951 W Pico Blvd, Ste 300, Los Angeles, CA 90064. To be effective, your opt-out notice
          must be postmarked within 30 days of your first use of Roaming Hunger’s
          Website. If you timely send this notice, then the obligation to
          arbitrate disputes will not apply to either party and you must litigate
          pursuant to the subparagraph below. If you do not timely send this
          notice, then you agree to be bound by this Arbitration Agreement in its
          entirety. Any hearing will be held in a location within 100 miles of
          your residence, unless you reside outside of the United States, and
          unless the parties agree otherwise. If you reside outside of the U.S.,
          the arbitrator shall give the parties reasonable notice of the date,
          time and place of any oral hearings. Any judgment on the award rendered
          by the arbitrator may be entered in any court of competent jurisdiction.
          Notwithstanding anything to the contrary in these Terms, if the
          arbitrator grants you an award that is greater than the last settlement
          offer that Roaming Hunger made to you prior to the initiation of
          arbitration, Roaming Hunger will pay you the greater of the award or US
          $2,500.
        </p>
        <p className="font-light text-sm my-2">
          If you or Roaming Hunger pursue arbitration, the arbitration action must
          be initiated and/or demanded within the statute of limitations (i.e.,
          the legal deadline for filing a claim) and within any deadline imposed
          under the AAA Rules for the pertinent claim.
        </p>
        <p className="font-light text-sm my-2">
          If arbitration is initiated, the arbitrator will decide the rights and
          liabilities, if any, of you and Roaming Hunger, and the dispute will not
          be consolidated with any other matters or joined with any other cases or
          parties. The arbitrator shall have the authority to grant motions
          dispositive of all or part of any claim. The arbitrator shall have the
          authority to award monetary damages, and to grant any non-monetary
          remedy or relief available to an individual under applicable law, the
          AAA Rules, and the Terms. The arbitrator shall issue a written award and
          statement of decision describing the essential findings and conclusions
          on which the award is based, including the calculation of any damages
          awarded. The arbitrator has the same authority to award relief on an
          individual basis that a judge in a court of law would have. The award of
          the arbitrator is final and binding upon you and Roaming Hunger.
        </p>
        <p className="font-light text-sm my-2">
          THE PARTIES HEREBY WAIVE THEIR CONSTITUTIONAL AND STATUTORY RIGHTS TO GO
          TO COURT (OTHER THAN A SMALL CLAIMS COURT) AND HAVE A TRIAL IN FRONT OF
          A JUDGE OR A JURY, instead electing that all claims and disputes shall
          be resolved by arbitration under this Arbitration Agreement. Arbitration
          procedures are typically more limited, more efficient and less costly
          than rules applicable in a court and are subject to very limited review
          by a court. In the event any litigation should arise between you and
          Roaming Hunger in any state or federal court in a suit to vacate or
          enforce an arbitration award or otherwise, YOU AND ROAMING HUNGER WAIVE
          ALL RIGHTS TO A JURY TRIAL, instead electing that the dispute be
          resolved by a judge.
        </p>
        <p className="font-light text-sm my-2">
          ALL CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION AGREEMENT
          MUST BE ARBITRATED OR LITIGATED ON AN INDIVIDUAL BASIS AND NOT ON A
          CLASS BASIS, AND CLAIMS OF MORE THAN ONE CUSTOMER OR USER CANNOT BE
          ARBITRATED OR LITIGATED JOINTLY OR CONSOLIDATED WITH THOSE OF ANY OTHER
          CUSTOMER OR USER.{' '}
        </p>
        <p className="font-light text-sm my-2">
          If any part or parts of this Arbitration Agreement are found under the
          law to be invalid or unenforceable, then such specific part or parts
          shall be of no force and effect and shall be severed and the remainder
          of the Terms shall continue in full force and effect.
        </p>
        <p className="font-light text-sm my-2">
          Any or all of the rights and limitations set forth in this Arbitration
          Agreement may be waived by the party against whom the claim is asserted.
          Such waiver shall not waive or affect any other portion of this
          Arbitration Agreement.
        </p>
        <p className="font-light text-sm my-2">
          This Arbitration Agreement will survive the termination of your user
          relationship with Roaming Hunger.
        </p>
        <p className="font-light text-sm my-2">
          Notwithstanding the foregoing, either you or Roaming Hunger may bring an
          individual action in small claims court.
        </p>
        <p className="font-light text-sm my-2">
          Notwithstanding the foregoing, either party may seek emergency
          injunctive relief before a state or federal court in order to maintain
          the status quo pending arbitration. A request for interim measures shall
          not be deemed a waiver of any other rights or obligations under this
          Arbitration Agreement.
        </p>
        <p className="font-light text-sm my-2">
          In any circumstances where the foregoing Arbitration Agreement permits
          the parties to litigate in court, and for claims involving users who
          have delivered an effective opt-out notice pursuant to the subparagraph
          above, the parties hereby agree to submit to the personal jurisdiction
          of the courts located within Los Angeles County, California, for such
          purpose.
        </p>
        <p className="font-light text-sm my-2">
          Notwithstanding any provision in these Terms to the contrary, we agree
          that if Roaming Hunger makes any future material change to this
          Arbitration Agreement, such change will not apply to any individual
          claim(s) for which you had already provided notice (to Roaming Hunger)
          prior to the effective date of the change.
        </p>

        <h2 className="font-normal text-2xl mt-2">Choice of Law</h2>
        <p className="font-light text-sm my-2">
          These Terms shall be governed by the laws of California, excluding any
          conflict of laws principles that would require the application of the
          laws of another jurisdiction.
        </p>

        <h2 className="font-normal text-2xl mt-2">Claims</h2>
        <p className="font-light text-sm my-2">
          YOU AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE
          SERVICE MUST COMMENCE WITHIN ONE YEAR AFTER THE CAUSE OF ACTION ACCRUES.
          OTHERWISE, THAT CAUSE OF ACTION IS PERMANENTLY BARRED.
        </p>

        <h2 className="font-normal text-2xl mt-2">
          Waiver and Severability of Terms
        </h2>
        <p className="font-light text-sm my-2">
          The failure of Roaming Hunger to exercise or enforce any right or
          provision of these Terms will not constitute a waiver of that right or
          provision. Any waiver of any provision of these Terms will be effective
          only if in writing and signed by Roaming Hunger. If any provision of
          these Terms is found by a court of competent jurisdiction to be invalid,
          the parties nevertheless agree that the court should endeavor to give
          effect to the parties’ intentions as reflected in the provision, and the
          other provisions of these Terms remain in full force and effect.
        </p>

        <h2 className="font-normal text-2xl mt-2">
          Consent to Electronic Communications
        </h2>
        <p className="font-light text-sm my-2">
          By using the Service, you consent to receiving electronic communications
          from us, including Roaming Hunger SMS. These communications may
          include notices about your account and information concerning or
          related to the Service. Message frequency varies. For contractual
          purposes, you (1) consent to receive communications from Roaming
          Hunger in an electronic form; and (2) agree that all terms and
          conditions, agreements, notices, disclosures, and other communications
          that Roaming Hunger provides to you electronically satisfy any legal
          requirement that such communications would satisfy if it were to be in writing. The foregoing does not affect
          your statutory rights. You are solely responsible for all fees charged
          by your telecommunications service provider or any other service
          provider related to your download of the App or use of the Service,
          including without limitation any SMS / text messaging fees, data charges,
          and other fees. Please note that carriers are not responsible for
          delayed or undelivered messages. To stop receiving messages, you may
          unsubscribe at any time by replying with the keyword STOP. After
          sending this message, you will receive a confirmation SMS, and no
          further messages will be sent to you. To rejoin, text START to +1 (213) 693-2335.
          If you need assistance with the SMS program, reply with “HELP” or contact
          us directly at support@roaminghunger.com. For
          details on how we handle your information, please review our 
          <a href="https://privacy.cptn.co/privacy-policy/6e1b0402-6e56-453c-9c37-de518dddb75d" className="text-blue font-bold underline"> Privacy Policy</a>.
        </p>

        <h2 className="font-normal text-2xl mt-2">Release</h2>
        <p className="font-light text-sm my-2">
          You hereby irrevocably release the Roaming Hunger Parties and their
          successors from claims, demands, any and all liabilities, losses,
          damages, rights, and actions of any kind, including personal injuries,
          death, and property damage, that is either directly or indirectly
          related to or arises from third-party websites, third-party products and
          services (including without limitation any food or beverage obtained
          through food trucks listed on the Service), or your use of the Service.
          If you are a California resident, you hereby waive California Civil Code
          Section 1542, which states, “A general release does not extend to claims
          which the creditor does not know or suspect to exist in his or her favor
          at the time of executing the release, which, if known by him or her must
          have materially affected his or her settlement with the debtor.”
        </p>

        <h2 className="font-normal text-2xl mt-2">Force Majeure</h2>
        <p className="font-light text-sm my-2">
          Roaming Hunger shall not be liable for any delay or failure to perform
          resulting from causes outside its reasonable control, including, but not
          limited to, acts of God, war, terrorism, riots, embargos, acts of civil
          or military authorities, fire, floods, accidents, strikes or shortages
          of transportation facilities, fuel, energy, labor or materials.
        </p>

        <h2 className="font-normal text-2xl mt-2">International Users</h2>
        <p className="font-light text-sm my-2">
          The Service can be accessed from countries around the world and may
          contain references to services and content that are not available in
          your country. These references do not imply that Roaming Hunger intends
          to introduce such services or content in your country. The Service is
          controlled and offered by Roaming Hunger from its facilities in the
          United States of America. Roaming Hunger makes no representations that
          the Service is appropriate or available for use in other locations.
          Those who access or use the Service from other jurisdictions do so at
          their own volition and are responsible for compliance with local law.
        </p>

        <h2 className="font-normal text-2xl mt-2">Export Control</h2>
        <p className="font-light text-sm my-2">
          You may not use, export, import, or transfer the Service except as
          authorized by U.S. law, the laws of the jurisdiction in which you
          obtained the Service, and any other applicable laws. In particular, but
          without limitation, the Service may not be exported or re-exported (a)
          into any United States embargoed countries; or (b) to anyone on the U.S.
          Treasury Department’s list of Specially Designated Nationals or the U.S.
          Department of Commerce’s Denied Person’s List or Entity List. By using
          the Service, you represent and warrant that (i) you are not located in a
          country that is subject to a U.S. Government embargo, or that has been
          designated by the U.S. Government as a “terrorist supporting” country
          and (ii) you are not listed on any U.S. Government list of prohibited or
          restricted parties. You also will not use the Service for any purpose
          prohibited by U.S. law, including the development, design, manufacture
          or production of missiles, nuclear, chemical or biological weapons. You
          acknowledge and agree that products, services or technology provided by
          Roaming Hunger are subject to the export control laws and regulations of
          the United States. You shall comply with these laws and regulations and
          shall not, without prior U.S. government authorization, export,
          re-export, or transfer any products, services or technology provided by
          Roaming Hunger, either directly or indirectly, to any country in
          violation of such laws and regulations.
        </p>

        <h2 className="font-normal text-2xl mt-2">Consumer Complaints.</h2>
        <p className="font-light text-sm my-2">
          In accordance with California Civil Code §1789.3, you may report
          complaints to the Complaint Assistance Unit of the Division of Consumer
          Services of the California Department of Consumer Affairs by contacting
          them in writing at 400 R Street, Sacramento, CA 95814, or by telephone
          at (800) 952-5210.
        </p>

        <h2 className="font-normal text-2xl mt-2">Entire Agreement</h2>
        <p className="font-light text-sm my-2">
          The Terms are the final, complete and exclusive agreement of the parties
          with respect to the subject matter hereof and supersedes and merges all
          prior discussions between the parties with respect to such subject
          matter.
        </p>

        <h2 className="font-normal text-2xl mt-2">Contacting Roaming Hunger</h2>
        <p className="font-light text-sm my-2">
          For questions, comments, complaints, or claims related to the Service,
          please contact Roaming Hunger at Roaming Hunger LLC, Attn: Support
          Team, 10951 W Pico Blvd, Ste 300, Los Angeles, CA 90064,
          1-800-568-9370, or&nbsp;
          <a
            className="text-blue font-bold"
            href="mailto:support@roaminghunger.com"
          >
            support@roaminghunger.com
          </a>
          . We will do our best to address your concerns. If you have a complaint
          and feel that your complaint has been addressed incompletely, we invite
          you to let us know for further investigation.
        </p>

        <hr className="my-12" />
      </TwoColumns>
    </Layout>
  )
}
